import { Roles } from '../constants/roles';
import { Priority } from '../model/interfaces';
import styles from '../styles/topic.module.scss';

function Topic(props: {
  title: string;
  repliesCount: number;
  creator: string;
  creationTime: string;
  lastPostTime: string;
  priority: Priority;
  onClick: () => void;
}) {
  return (
    <div className={styles.topic} onClick={props.onClick}>
      <div className={styles.title}>
        <p>{props.title}</p>
      </div>
      <div className={styles.category}>
        <p>{props.repliesCount}</p>
        <p className={styles.date}>{props.lastPostTime}</p>
      </div>
      <div className={styles['category-posted']}>
        <p className={styles[`priority-${props.priority}`]}>{`${props.creator} ${Roles[props.priority]}`}</p>
        <p className={styles.date}>{props.creationTime}</p>
      </div>
    </div>
  );
}

export default Topic;
